<section class="facility-section">
  <div class="carousel-center" *ngIf="pageData$ | async">
    <div class="facilitycarousel" #facilityCarousel
         (mouseenter)="pause()"
         (mouseleave)="play()">

      <div class="track">
        <div class="facility-card" *ngFor="let f of congiguredFacilities">
          <div class="image-wrapper">
  <img [src]="f.fileUrl">
</div>

          <div class="card-body">
            <div class="title-strip">
              <h2>{{ f.title }}</h2>
            </div>
            <p>{{ f.desc }}</p>
          </div>
          
        </div>
      </div>

    </div>
  </div>
</section>
